import React from 'react';
import PropTypes from 'prop-types';
import { PageLayout } from 'common/components';
import LeanPay from '../../_components/LeanPay';

const LeanPayPage = ({ match, location }) => {
  // 从 URL 参数中获取值
  const searchParams = new URLSearchParams(location.search);
  const appToken = searchParams.get('app_token');
  const sdkToken = searchParams.get('sdk_token');
  const customerId = searchParams.get('customer_id');
  const depositId = searchParams.get('deposit_id');

  // 从 match.params 中获取路由参数
  const { accountId } = match.params;

  return (
    <PageLayout captionSlug="leanPay">
      <LeanPay
        appToken={appToken}
        sdkToken={sdkToken}
        customerId={customerId}
        depositId={depositId || accountId}
        isSandbox={window.location.hostname !== 'my.dolmarkets.com'}
      />
    </PageLayout>
  );
};

LeanPayPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      accountId: PropTypes.string,
    }),
  }),
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

LeanPayPage.defaultProps = {
  match: { params: {} },
  location: { search: '' },
};

export default LeanPayPage;
